import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

//import models
import { loginApi } from "../../api";
import {
  KISAUser,
  initializeKisaUser,
  KISAUserLoginRequest,
} from "../../models/KISAUser";
import { toastPopupOpenAction } from "./interactionReducer";

export const getAuth = createAsyncThunk(
  "/login",
  async (params: KISAUserLoginRequest, { dispatch }) => {
    try {
      const requestParams: KISAUserLoginRequest = {
        loginID: params.loginID,
        loginPW: params.loginPW,
      };
      return await axios
        .post(loginApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (data.isAuth) {
            dispatch(
              toastPopupOpenAction({
                contents: "로그인 되었습니다.",
                severity: "info",
              })
            )
          }
          else {
            dispatch(
              toastPopupOpenAction({
                contents: "로그인에 실패했습니다.",
                severity: "error",
              })
            );
          }
          return data;
        });
    } catch (error) {
      throw new Error("네트워크에러");
    }
  }
);

interface auth {
  loading: boolean;
  error: string;
  isAuth: boolean;
  user: KISAUser;
  userToken: string;
  message: string;
  autoLogin: boolean;
}
const initialState: auth = {
  loading: true,
  error: "",
  isAuth: false,
  user: {} as KISAUser,
  userToken: "",
  message: "",
  autoLogin: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // note SmokingScully 2022-03-02 추가
    logOutAction: (state): void => {
      state.isAuth = false;
      state.user = initializeKisaUser;
      state.userToken = "";
    },
    alterUserAction: (state, action): void => {
      state.user = action.payload.item;
    }
  },
  extraReducers: {
    [getAuth.pending.type]: (state) => {
      state.loading = true;
    },
    [getAuth.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.isAuth = action.payload.isAuth;
      state.user = action.payload.item;
      state.userToken = action.payload.token;
      state.message = action.payload.message;
    },
    [getAuth.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
  },
});

export const {
  logOutAction,
  alterUserAction,
} = authSlice.actions;

export default authSlice.reducer;
